import React from 'react';
import { URGENCY_OPTIONS, URGENCY_STYLES } from '../utils/constants';

export const UrgencySelector = ({ value, onChange, label = 'Urgency', labelClassName = '' }) => (
  <div className="mb-5">
    {label && (
      <label className={`block text-sm mb-2 text-slate-800 ${labelClassName || 'font-semibold'}`}>
        {label}
      </label>
    )}
    <div className="grid grid-cols-4 gap-2">
      {URGENCY_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`py-2.5 px-3 border rounded-lg text-center cursor-pointer text-sm font-medium 
            transition-all font-sans
            ${value === option.value
              ? `border ${URGENCY_STYLES[option.value]}`
              : 'border-slate-200 bg-white text-slate-700 hover:border-slate-300'
            }`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  </div>
);
